import React from "react";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  Image,
  ToggleSwitchWrapper,
} from "./NavbarElement";
import { FaBars } from "react-icons/fa";
import { ThemeContext } from "../../ContextProvider/ThemeContextProvider";
import ToggleSwitch from "../../Utils/ToggleSwitch/ToggleSwitch";

const Navbar = () => {
  const { handleOpen, mode } = React.useContext(ThemeContext);
  return (
    <>
      <Nav theme={mode}>
        <NavbarContainer>
          <NavLogo href="https://portfolio-rohan.netlify.app/">
            <Image
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQ3IiBoZWlnaHQ9IjIxMCIgdmlld0JveD0iMCAwIDI0NyAyMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjI2NSIgaGVpZ2h0PSIyMTAiPgo8cmVjdCB3aWR0aD0iMjY1IiBoZWlnaHQ9IjIxMCIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazApIj4KPHBhdGggb3BhY2l0eT0iMC44IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuMDMyNzEgMjIwLjM0MUMtMTMuMzYzMiAyNDguNzgyIC0zLjYxNTc5IDI4NS4xNiAyNC44MDQyIDMwMS41OTNMMTQ5Ljc3NCA4NC44MTE4QzE2Ni4xNyA1Ni4zNzA0IDE1Ni40MjMgMTkuOTkyNCAxMjguMDAzIDMuNTU5MzNMMy4wMzI3MSAyMjAuMzQxWk00My44OTAyIDI3Ny44NjlDMjcuNDk0MyAzMDYuMzEgMzcuMjQxNyAzNDIuNjg4IDY1LjY2MTcgMzU5LjEyMUwxOTAuNjMyIDE0Mi4zNEMyMDcuMDI4IDExMy44OTkgMTk3LjI4IDc3LjUyMDYgMTY4Ljg2IDYxLjA4NzZMNDMuODkwMiAyNzcuODY5Wk0xMDYuNTE5IDQxNS4yOTRDNzguMDk5MiAzOTguODYxIDY4LjM1MTggMzYyLjQ4MyA4NC43NDc3IDMzNC4wNDFMMjA5LjcxOCAxMTcuMjZDMjM4LjEzOCAxMzMuNjkzIDI0Ny44ODUgMTcwLjA3MSAyMzEuNDg5IDE5OC41MTJMMTA2LjUxOSA0MTUuMjk0WiIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyKSIvPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSIwIiB5MT0iMCIgeDI9IjIwMy45NjYiIHkyPSIyNTcuMzg2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM2QTk4RjAiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNDk2MURDIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhciIgeDE9Ii00LjkyNjc2IiB5MT0iMy41NTkzMyIgeDI9IjM1NS42NTkiIHkyPSIyMTcuNTc2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM2QTk4RjAiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNDk2MURDIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg=="
              alt="logo-img"
            />
          </NavLogo>
          <MobileIcon theme={mode} onClick={handleOpen}>
            <FaBars style={{ color: "rgb(109, 131, 242)" }} />
          </MobileIcon>
          <NavMenu>
            <NavItem>
              <NavLinks href="#home" theme={mode}>
                Home
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks href="#about" theme={mode}>
                About
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks href="#projects" theme={mode}>
                Project
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks href="#skills" theme={mode}>
                Skills
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks href="#experience" theme={mode}>
                Experience
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks href="#contact" theme={mode}>
                Contact Me
              </NavLinks>
            </NavItem>
          </NavMenu>
          {/* Light dark toggle button */}
          <ToggleSwitchWrapper>
            <ToggleSwitch />
          </ToggleSwitchWrapper>
        </NavbarContainer>
      </Nav>
    </>
  );
};

export default Navbar;
